import { defineStore } from 'pinia'
import { ref } from 'vue'
import { keyBy } from 'lodash'
import { PulseWorkflowProgress, PulseReconciliationStatusData } from '../types'
import { getPulseReconciliationStatusKey } from './utils'
import decompressWorkflowProgresses from '@app/application/workflows/utils/workflow_progress_decompressor'

export const usePulseWorkflowProgress = defineStore(
  'pulseWorkflowProgress',
  () => {
    const reconciliationStatuses = ref<
      Record<string, PulseReconciliationStatusData>
    >({})

    const lastReceived = ref<number>(0)
    const workflowProgress = ref<number | null>(null)
    const error = ref<boolean | undefined>(false)

    function clearLastReceived(): void {
      lastReceived.value = 0
    }

    function receivePulseWorkflowProgress(data: PulseWorkflowProgress): void {
      error.value = data.error
      workflowProgress.value = data.progress

      const statuses = decompressWorkflowProgresses(
        data.statuses
      ) as Array<PulseReconciliationStatusData>

      reconciliationStatuses.value = keyBy(statuses, (item) =>
        getPulseReconciliationStatusKey(item)
      )

      lastReceived.value = Date.now()
    }

    return {
      clearLastReceived,
      lastReceived,
      receivePulseWorkflowProgress,
      reconciliationStatuses,
      workflowProgress,
      error,
    }
  }
)
